import axios from "axios"

export default function checkResetPasswordResendTimeLeft({ email }) {
    return new Promise((resolve, reject) => {
        axios.post("account/public/api/v1/check-reset-password-resend-time-left", {email})
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}